const MONDOO_URL = "mondoo.com/";

export const removeMondooLink = (value: string) => {
  return value.startsWith(MONDOO_URL) ? value.slice(MONDOO_URL.length) : value;
};
